import axios from "@/axios";
import { mapActions } from "vuex";
import Loader from "@shared/loader";
import LoaderFull from "@/components/loader-full";
import sectionLists from "@/pages/check-admin/check-dragable-section/components/sectionLists";
import Button from "@/components/button";
const modalConfirm = () => import("@/components/modal-confirm");
import Empty from "@shared/empty";
import ListView from "@shared/components/list-view";
import ModalContent from "@shared/modal-content";
import { checkPermission } from "@shared/utils/functions"
import PackagesTemplate from "@shared/components/package-templates"
import dropdown from "@shared/components/dropdown-base";
import draggable from 'vuedraggable';
import { fetchPackageTemplatesList } from "@shared/workflow/service.js";
import { getTenantTemplates } from "@/modules/packages/services.js";

export default {
    name: "package-template",
    props: {},
    components: {
        sectionLists,
        Loader,
        Button,
        modalConfirm,
        Empty,
        ModalContent,
        LoaderFull,
        ListView,
        dropdown,
        draggable,
        PackagesTemplate
    },
    data() {
        return {
            tenantId: null,
            isLoading: false,
            packageId: null,
            sectionList: [],
            fieldToAdd: {
                section: null,
                block: null,
                field: null,
                permisions: null,
                report_visibility: null,
            },
            loadingState: {
                addFields: false,
                getDependent: false,
                templates: false,
                dateType: false,
            },
            queryData: null,
            fieldTypeFilter: [],
            isDragging: true,
            options: {
                shortKey: [
                    { title: "Custom List", value: "CUSTOM" },
                    { title: "A to Z", value: "ASC" },
                    { title: "Z to A", value: "DESC" },
                ],
            },
            selectedData: 'Sort By : A to Z',
            showSidePanel: false,
            activeFieldPanel: null,
            dependentsFields: [],
            drag: false,
            loadingLists: false,
            searchForm: "",
            assignedTemplates: [],
            tenantTemplates: [],
            showBlockAddModal: false,
            isGlobalLoader: {
                status: false,
                message: ''
            },
        };
    },
    async mounted() {
        this.isLoading = true;
        this.packageId = this.$route.params.packageName;
        this.tenantId = this.$store.getters.getTenantId;
        this.queryData = this.$route.params?.action
        await this.fetchTemplates();
    },
    watch: {},
    computed: {
        has_templates() {
            return this.assignedTemplates?.length > 0;
        },
        isUserPermission() {
            let permissions = {
                READ_TEMPLATE: this.checkPermission("package.readTemplate"),
                EDIT_TEMPLATE: this.checkPermission("package.editTemplate"),
            };
            return permissions;
        },
        isEditPermission() {
            if (this.isUserPermission) {
                return (this.isUserPermission.EDIT_TEMPLATE)
            } else {
                return false
            }
        },
        isReadPermission() {
            if (this.isUserPermission) {
                return (this.isUserPermission.READ_TEMPLATE)
            } else {
                return false
            }
        },
        disabledDragging() {
            return this.querydata === 'view' || this.selectedData !== 'Sort By : Custom List';
        }
    },
    methods: {
        getAddTemplateList() {
            const assignedIds = new Set(this.assignedTemplates.map(t => t.admin_template_id));
            return this.tenantTemplates.filter(el => !assignedIds.has(el.admin_template_id) && el.template_name.toLowerCase().includes(this.searchForm.toLowerCase()));
        },
        checkPermission,
        ...mapActions([
            "fetchPackageEntitySections",
            "fetchPackageData",
            "fetchPackageChecks",
            "fetchPackageFormsByEntity",
            "fetchFormRows",
        ]),
        startDragging() {
            this.isDragging = true;
        },
        stopDragging(e) {
            console.log('Drag ended:', e);
            this.isDragging = false;
        },
        async onReorder(e) {
            if (e.moved) {
                const oldIndex = e.moved.oldIndex;
                const newIndex = e.moved.newIndex;
                const removed = this.assignedTemplates.splice(oldIndex, 0);  

                this.assignedTemplates.splice(newIndex, 0, ...removed);   

                // const section_list = [];
                // this.assignedTemplates.forEach((item, index) => {
                //     item.order = index;
                //     section_list.push({ section_id: item.id, order: index + 1 });
                // });

                const payload = {
                    "form_order_type": "CUSTOM",
                    "forms":  this.assignedTemplates.map(item => item.id),
                };

                this.handleControlGlobalLoader(true, this.$t('components.tenant.tenant_packages.reordering'));
                await this.fetchSortOptions(payload);
            }
        },

        handleFilterFormResult(search) {
            return this.searchForm = search;
        },
        
        // Get template data
        async fetchTemplates() {
            try {
                const response = await fetchPackageTemplatesList(this.packageId); // this.packageId 
                // const sortObject = this.options.shortKey.find((el) => el.value === this.getPackageFormsSortOrder );
                // this.selectedData = "Sort By : " + sortObject.title;
                this.assignedTemplates = response;
                this.isLoading = false;
            } catch (error) {
                console.log(error, "[+]error while fetching form");
                this.isLoading = false;
            }
        },

        // Side Panel Settings
        handleClosePanel() {
            this.showSidePanel = false;
            this.activeFieldPanel = {
                field: null,
                section: null,
            };
        },

        onShowPanel(element, section) {
            if (element.is_cascaded) return;
            this.handleShowPanel(element, section);
        },

        async handleShowPanel(element, section) {
            if (!element.fields) {
                element.roles = element?.roles.map((role) => ({ ...role, select_all: role.role_mandatory && role.role_read && role.role_visible && role.role_write }));
                this.showSidePanel = true;
                this.activeFieldPanel = {
                    field: element,
                    section: section,
                    is_cascaded: element.is_cascaded,
                };
                if (element.is_cascaded) {
                    this.loadingState.getDependent = true;
                    try {
                        const { data } = await axios.get(`/package-section/${this.packageId}/section/${section.id}/field/${element.id}/dependents`);
                        this.dependentsFields = data.dependents;
                    } catch (error) {
                        console.log("error :>> ", error);
                    }
                    this.loadingState.getDependent = false;
                }
            }
        },

        // Change role permission

        PermissionChange(role) {

            if (role.role_mandatory) {
                role.role_read = true;
                role.role_write = true;
                role.role_visible = true;
                role.select_all = true;
            } else if (role.role_write) {
                role.role_read = true;
                role.role_visible = true;
                role.select_all = false;
            } else if (role.role_read) {
                role.role_visible = true;
                role.select_all = false;
            }
        },

        // End Field modal show

        // Close Field Modal

        closefieldAddModal() {
            this.showBlockAddModal = false
        },

        // End Close field modal

        // select all permissions

        handleSelectAllPermission(role) {
            let permisions = this.fieldToAdd.permisions;
            if (role.select_all) {
                permisions.map((el) => {
                    if (el.id === role.id) {
                        el.role_read = true;
                        el.role_write = true;
                        el.role_visible = true;
                        el.role_mandatory = true;
                    }
                });
            } else {
                permisions.map((el) => {
                    if (el.id === role.id) {
                        el.role_read = false;
                        el.role_write = false;
                        el.role_visible = false;
                        el.role_mandatory = false;
                    }
                });
            }
            this.fieldToAdd.permisions = permisions;
        },

        handleSelectAllFieldPermission(role) {
            this.activeFieldPanel.field.roles.map((el) => {
                // NOTE: FIX THIS

                if (el.id === role.id) {
                    if (role.select_all) {
                        el.role_read = true;
                        el.role_write = true;
                        el.role_visible = true;
                        el.role_mandatory = true;
                    } else {
                        el.role_read = false;
                        el.role_write = false;
                        el.role_visible = false;
                        el.role_mandatory = false;
                    }
                }
            });
        },

        // Reordering section and Fields

        // reorder section
        async handleSectionReorder(e) {
            if (e.moved) {
                const section_list = [];
                
                const removed = this.sectionList.splice(e.moved.oldIndex, 1);
                this.sectionList.splice(e.moved.newIndex, 0, ...removed);

                this.sectionList.forEach((i, ind) => {
                    i.order = ind;
                    section_list.push({ section_id: i.id, order: ind + 1 })
                });

                const formId = this.sectionList[0].formId;
                const url = `/package-section/form/${formId}/section/reorder`;

                let payload = {
                    section_list: section_list,
                };
                this.handleControlGlobalLoader(true, this.$t('components.tenant.tenant_packages.reordering'));
                try {
                    const { data } = await axios.post(url, payload);
                    this.$toast.success(data.message);
                } catch (error) {
                    this.$toast.error(error.response.data.detail || this.$t('components.tenant.tenant_packages.section_reorder_fail'));
                } finally {
                    this.handleControlGlobalLoader(false);
                }
            }
        },

        /* async onAddTemplate() { */
        async onAddTemplate() {
            if (this.$route.params.action == 'view') {
                return
            }
            this.$refs["add-form-modal"].showModal();
            this.loadingState.templates = true;
            try {
                const response = await getTenantTemplates();
                this.tenantTemplates = response;
                this.loadingState.templates = false;
            } catch (error) {
                console.error('Failed to fetch template permissions', error);
                this.loadingState.templates = false;
            }
            
            this.loadingState.templates = false;
        },
        async addTemplateToPack(template) {
            this.loadingState.templates = true;
            try {
                const { data } = await axios.post(`/report-builder/package/${this.packageId}/template/${template.id}/assign`);
                // await this.fetchScreeningData();
                await this.fetchTemplates();
                this.$toast.success(data.message || this.$t('components.tenant.tenant_packages.template_add_success'));
            } catch (error) {
                this.$toast.error(error.response.data.detail || this.$t('components.tenant.tenant_packages.template_add_fail'));
            }
            this.onBeforeOpenSearch()
            this.loadingState.templates = false;
        },
        async removeTemplateFromPackage(template) {
            if (template.disabled || this.$route.params.action == 'view') {
                return
            }
            const promise = await this.$refs["confirm-popup"].show({
                title: this.$t('general.are_you_sure'),
                message: this.$t('components.tenant.tenant_packages.template_delete_confirm'),
            });
            if (promise) {
                const url = `/report-builder/package/${this.packageId}/template/${template.id}/unassign`;

                try {
                    const data = await axios.post(url);
                    // await this.fetchScreeningData();
                    await this.fetchTemplates();
                    this.$toast.success(data.message || this.$t('components.tenant.tenant_packages.template_delete_success'));
                } catch (error) {
                    this.$toast.error(error.response.data.detail || this.$t('components.tenant.tenant_packages.template_delete_fail'));
                }
            }
            this.$refs["confirm-popup"].close();
            // this.checks.push(check)
        },
        onBeforeOpenSearch() {
            this.searchForm = "";
            this.fieldTypeFilter = []
        },
        async getOptions(field_id) {
            const result = await axios.get(`/package-section/${this.packageId}/field/${field_id}/options`);
            return result;
        },
        async getDependents(field_id, option_value) {
            const result = await axios.get(`/package-section/field/${field_id}/options/${option_value}/dependents`);
            return result;
        },

        async fetchSortOptions(value) {
            try {
                let url = `/report-builder/${this.packageId}/templates/reorder`;
                let { data } = await axios.post(url, value);
                this.$toast.success(data.message || "Updated Successfully.");
                this.fetchTemplates()

            } catch (error) {
                console.log(error, "error>>>>>");
            } finally {
                this.handleControlGlobalLoader(false);
            }
        },
        handleFilterActivity(value) {
            let payload;
            this.selectedData = this.$t('components.tenant.tenant_packages.sort_by', { value: value.title })
            if (value.value === "ASC") {
                payload = {"report_template_order_type": "ASC"}
            } else if (value.value === "DESC") {
                payload ={"report_template_order_type": "DESC"}
            } else if (value.value === "CUSTOM") {
                const templateIdArr = this.assignedTemplates.map(template => template.id)
                payload = {
                    "report_template_order_type": "CUSTOM",
                    "templates": templateIdArr
                }
            }
            this.handleControlGlobalLoader(true, this.$t('components.tenant.tenant_packages.changing_sort_by'))
            this.fetchSortOptions(payload);
        },
        handleControlGlobalLoader(status, message) {
            this.isGlobalLoader = {
                status,
                message: message || this.$t('general.loading_dots')
            }
        },
    }
};
